import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import PaymentPage from "@/pages/PaymentPage";
import BillingReturn from "@/pages/BillingReturn";

import PrivateRoute from "@/components/PrivateRoute";
import AppShell from "@/components/AppShell";

import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import Jobs from "@/pages/Jobs";
import CalendarPage from "@/pages/CalendarPage";
import DailyRoute from "@/pages/DailyRoute";
import MapView from "@/pages/MapView";
import Invoices from "@/pages/Invoices";
import Staff from "@/pages/Staff";
import Settings from "@/pages/Settings";
import Admin from "@/pages/Admin";
import Emails from "@/pages/Emails";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/pay/:token" element={<PaymentPage />} />
            <Route path="/billing/return" element={<BillingReturn />} />

            <Route path="/app" element={<PrivateRoute><AppShell /></PrivateRoute>}>
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="customers" element={<Customers />} />
              <Route path="jobs" element={<Jobs />} />
              <Route path="calendar" element={<CalendarPage />} />
              <Route path="route" element={<DailyRoute />} />
              <Route path="map" element={<MapView />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="staff" element={<Staff />} />
              <Route path="settings" element={<Settings />} />
              <Route path="emails" element={<Emails />} />
              <Route path="admin" element={<Admin />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
